import * as FilePond from 'filepond';
import * as FilePondPluginFileValidateSize from '../../../node_modules/filepond-plugin-file-validate-size/dist/filepond-plugin-file-validate-size.js'
import * as FilePondPluginFileValidateType from '../../../node_modules/filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.js'
import * as FilePondPluginFileEncode from "../../../node_modules/filepond-plugin-file-encode/dist/filepond-plugin-file-encode.js"

document.addEventListener('DOMContentLoaded', function () {
  FilePond.registerPlugin(FilePondPluginFileValidateType);
  FilePond.registerPlugin(FilePondPluginFileValidateSize);
  FilePond.registerPlugin(FilePondPluginFileEncode);

  var inputElement = document.querySelector('#fileupload');
  var pond = FilePond.create(inputElement, {
    allowMultiple: true,
    maxFiles: 5,
    credits: false,
    maxTotalFileSize: 25000000,
    maxFileSize: 25000000,
    acceptedFileTypes: ["image/jpeg", "image/png", "image/gif", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.oasis.opendocument.text", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel", "application/zip", "text/plain", "application/rtf", "application/vnd.rar"],
    fileValidateTypeLabelExpectedTypes: ""
  });

  pond.on('addfile', (error, file) => {
    if (error) {
      setTimeout(() => {
        pond.removeFile(file);
      }, 1000)
      return;
    }
  });
})